import V1PasswordPage from '@/pages/v1/signUp/PasswordPage'
import V2PasswordPage from '@/pages/v2/signUp/PasswordPage'
import { useABTestVariant } from '@app-studio-web/ui/contexts/ABTestContext'
import BaselinePasswordPage from '@app-studio-web/ui/pages/signUp/PasswordPage'

export default function VariantPasswordPage() {
  const { variant } = useABTestVariant()

  switch (variant) {
    case 'v1':
      return <V1PasswordPage />
    case 'v2':
      return <V2PasswordPage />
    default:
      return <BaselinePasswordPage />
  }
}
